import { render, staticRenderFns } from "./PricePanelTypeAddForm.vue?vue&type=template&id=02080390"
import script from "./PricePanelTypeAddForm.vue?vue&type=script&lang=js"
export * from "./PricePanelTypeAddForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports